import { Component } from "@angular/core";
import { Observable } from "rxjs";

import { AuthService } from "../core/auth.service";
@Component({
    selector: "app-menu",
    templateUrl: "./app-menu.component.html",
    styleUrls: ["./app-menu.component.css"],
    standalone: false
})
export class AppMenuComponent {
  isAuthenticated$: Observable<boolean>;
  canAccessExperianPayersUpload$: Observable<boolean>;
  public pageTitle = "Rapid Verify";
  constructor(private authService: AuthService) {
    this.isAuthenticated$ = authService.isAuthenticated$;
    this.canAccessExperianPayersUpload$ =
      authService.canAccessExperianPayersUpload;
  }

  login() {
    this.authService.login();
  }
  logout() {
    this.authService.logout();
  }

  get email(): string {
    return this.authService.identityClaims
      ? (this.authService.identityClaims as any)["email"]
      : "-";
  }
}
